"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTickerBatch = exports.useAllTicker = exports.useTicker = void 0;
const react_1 = require("react");
const operators_1 = require("rxjs/operators");
const Interfaces_1 = require("../Interfaces");
const QuotationSocketMgr_1 = require("../QuotationSocketMgr");
const DefaultMap = new Map();
const parseExchangeFromCoin = (base, exchange) => {
    if (exchange) {
        return exchange;
    }
    else if (base) {
        const isBinance = base.endsWith(".SWAP") || base.endsWith(".CMSWAP");
        return isBinance ? Interfaces_1.EXCHANGE_PIONEX_SWAP : Interfaces_1.EXCHANGE_PIONEXV2;
    }
    else {
        return Interfaces_1.EXCHANGE_PIONEXV2;
    }
};
function parseTickerOb(ob, interval, onlyOnce) {
    let ticker$ = ob.pipe((0, operators_1.throttleTime)(interval));
    // 是否只要一次
    if (onlyOnce) {
        ticker$ = ticker$.pipe((0, operators_1.filter)((e) => {
            return !!e;
        }), 
        // 第一次可能为缓存
        (0, operators_1.skip)(1), (0, operators_1.take)(1));
    }
    return ticker$;
}
/**
 * 获取ticker的hooks
 * @param params
 * @returns
 */
const useTicker = (params) => {
    const { base, quote, exchange, interval = 0, isActive = true, onlyOnce = false } = params;
    const [ticker, setTicker] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        if (!base || !quote) {
            setTicker(undefined);
        }
    }, [base, quote]);
    (0, react_1.useEffect)(() => {
        if (!isActive || !base || !quote) {
            return;
        }
        const parseExchange = parseExchangeFromCoin(base, exchange);
        const ticker$ = (0, QuotationSocketMgr_1.getGlobalQuotationSocketMgr)().getTickerWebSocket().getTickerObservableByPair(parseExchange, base, quote);
        const sub = parseTickerOb(ticker$, interval, onlyOnce).subscribe({
            next: (data) => {
                setTicker(data);
            },
            error: () => { },
        });
        return () => {
            sub.unsubscribe();
        };
    }, [base, exchange, interval, isActive, onlyOnce, quote]);
    return ticker;
};
exports.useTicker = useTicker;
/**
 * 获取整个交易所的ticker
 * @param params
 * @returns
 */
const useAllTicker = (params) => {
    const { exchange = Interfaces_1.EXCHANGE_PIONEXV2, interval = 0, isActive = true, onlyOnce = false } = params;
    const [ticker, setTicker] = (0, react_1.useState)(DefaultMap);
    (0, react_1.useEffect)(() => {
        if (!isActive || !exchange) {
            return;
        }
        const ticker$ = (0, QuotationSocketMgr_1.getGlobalQuotationSocketMgr)().getTickerWebSocket().getTickerObservableByEx(exchange);
        const sub = parseTickerOb(ticker$, interval, onlyOnce).subscribe({
            next: (data) => {
                setTicker(data);
            },
            error: () => { },
        });
        return () => {
            sub.unsubscribe();
        };
    }, [exchange, interval, isActive, onlyOnce]);
    return ticker;
};
exports.useAllTicker = useAllTicker;
function useTickerBatch(params) {
    const { symbols, exchange = Interfaces_1.EXCHANGE_PIONEXV2, interval = 0, isActive = true, onlyOnce = false } = params;
    const [tickerMap, changeTickerMap] = (0, react_1.useState)(new Map());
    const depString = (0, react_1.useMemo)(() => {
        return symbols.sort().join("|");
    }, [symbols]);
    (0, react_1.useEffect)(() => {
        if (symbols.length <= 0 || !isActive) {
            return;
        }
        const symbolPairInfoMapped = symbols.map((pairInfo) => {
            return {
                market: exchange,
                base: pairInfo.base,
                quote: pairInfo.quote,
            };
        });
        const tickerMap$ = (0, QuotationSocketMgr_1.getGlobalQuotationSocketMgr)().getTickerWebSocket().getTickerObservableBatchMap(symbolPairInfoMapped);
        const subscription = parseTickerOb(tickerMap$, interval, onlyOnce).subscribe({
            next: (result) => {
                changeTickerMap(result);
            },
            error: (error) => { }
        });
        return () => {
            subscription && subscription.unsubscribe();
        };
        // 用depString代替symbols依赖
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isActive, depString, interval, onlyOnce, exchange]);
    return tickerMap;
}
exports.useTickerBatch = useTickerBatch;
